import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import { Row, Col, Container, Card,CardDeck } from 'react-bootstrap'
import Select from 'react-select'
import GroupVRNSelect from '../../containers/comps/GroupVRNSelectContainer'
import HomeMini from '../../components/HomeMini';
import axiosConfig from '../../config/axiosConfig'


const firstDate = new Date();
const currentDate = new Date();

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'black' : 'black',
        backgroundColor: state.isSelected ? 'yellow' : 'white'
    }),
    control: (provided) => ({
        ...provided,
        borderRadius: '50px',
        borderColor: 'Yellow'

    })
}


function Iframe(props) {
    console.log("URL Calling : ", props.src)
    return (
        <div>
            <iframe src={props.src} height={props.height} width={props.width} allowFullScreen={true} style={{ border: 0 }} />
        </div>
    )
}

class HSSEAnalysis extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showReport: false,
            firstDay: new Date(firstDate.getFullYear(), firstDate.getMonth(), 1),
            fromDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 2).toISOString().substring(0, 10), //new Date(date.getFullYear(), date.getMonth(), 1);
            toDate: new Date().toISOString().substring(0, 10),

            timeFrameDropDownOptionsNew: [
                { value: 'three_month', label: 'Last 3 months' },
                { value: 'six_month', label: 'Last 6 months' },
                { value: 'tweleve_month', label: 'Last 12 months' }
            ],

            "OVER_SPEEDING": {
                currentMonthReading: 0,
                previosMonthReading: 0,
                percentDifferent: 1
            },
            "HARSH_BRAKING": {
                currentMonthReading: 59,
                previosMonthReading: 60,
                percentDifferent: 1
            },
            "HARSH_TURN": {
                currentMonthReading: 0,
                previosMonthReading: 0,
                percentDifferent: 1
            },
            "SEAT_BELT_VIOLATION": {
                currentMonthReading: 0,
                previosMonthReading: 0,
                percentDifferent: 1
            },
            "IDLING_TIME": {
                currentMonthReading: 0,
                previosMonthReading: 0,
                percentDifferent: 1
            },
            "HARSH_ACCELERATION": {
                currentMonthReading: 0,
                previosMonthReading: 0,
                percentDifferent: 1
            },
            "HSSE_SCORE": {
                currentMonthReading: 0,
                previosMonthReading: 0,
                percentDifferent: 0
            },

            data: [],

            Option: 1,
            Group: 0,
            Vehicle: 0,
            TimeFrameId: 1,

            searchCriteria2: 'vrn',
            Option2: 'vrn',
            Group2: '0',
            Group2Id: '',
            Vehicle2: '',
            Vehicle2Id: '',
            TimeFrameId2: 'three_month',


            searchCriteria1: 'vrn',
            Option1: 'vrn',
            Group1: '0',
            Group1Id: '',
            Vehicle1: '',
            Vehicle1Id: '',
            TimeFrameId1: 'three_month',

            srcURL_HSSEBulletin: '',

            srcURL_HSSEScore_bar: '',
            srcURL_HSSEIncidents_bar: '',
            //reportBaseURL: 'http://localhost:40383/Charts?',
            reportBaseURL: 'https://shelltelematics.pk/TELEMATICSREPORTINGSERVICE/Charts?',
            reportExtraParams: '&rs:Command=Render&rc:Parameters=false&',
            reportViewType: '/SSSAS_TabularReports/',
            VRNMappingMasterId: '',
            VRNGroupMasterId: '',

        };

        this.changeOptionTime2 = this.changeOptionTime2.bind(this)

        this.optionChange2 = this.optionChange2.bind(this)
        this.groupChange2 = this.groupChange2.bind(this)
        this.vehicleChange2 = this.vehicleChange2.bind(this)

        this.HSSEIncident_bar = this.HSSEIncident_bar.bind(this)
        this.HSSEScore_bar = this.HSSEScore_bar.bind(this)

        this.BulletInOptionChange = this.BulletInOptionChange.bind(this)
        this.BulletInVehicleChange = this.BulletInVehicleChange.bind(this)
        this.BulletInGroupChange = this.BulletInGroupChange.bind(this)

    }


    getHSSEAnalyticsData() {
        axiosConfig.post('Portal/GetFuelingSafetyEventData', {
            "UserAccountBranchID": localStorage.getItem('selectedBranch'),
            "SearchTypeId": 1,
            "CardMappingMasterId": 0,
            "VRNGroupMasterId": 0,
            "StartTime": this.state.fromDate,
            "EndTime": this.state.toDate,
            // "NoOfRecords":10
        })
            .then((res) => {
                for (var i = 0; i < res.data.eventAnalytics.length; i++) {
                    this.setState((prevState) => ({
                        [res.data.eventAnalytics[i].event]: {
                            currentMonthReading: res.data.eventAnalytics[i].currentMonthReading,
                            percentDifferent: res.data.eventAnalytics[i].percentDifferent,
                            previosMonthReading: res.data.eventAnalytics[i].previosMonthReading,
                        }
                    }));
                }
            })
            .catch(console.error)
            .finally(() => {
            });
    }


    componentDidMount() {

        this.HSSEIncident_bar();
        this.HSSEScore_bar();

        //this.getHSSEAnalyticsData();

        this.getTabularData();

    }

    /*Start:For Bar Chart*/
    async changeOptionTime2(selectedOption) {

        await this.setState({ TimeFrameId2: selectedOption.value })
    }

    async optionChange2(selectedOption) {

        if (selectedOption == 1) {

            await this.setState({ Option2: selectedOption, Group2: 0, Vehicle2: 0 })
            await this.setState({ searchCriteria2: "vrn" })
            this.HSSEIncident_bar();
            this.HSSEScore_bar();
        }
        else
            await this.setState({ Option2: selectedOption, Group2: 0, Vehicle2: 0 })
    }

    async vehicleChange2(selectedVehicle) {


        await this.setState({ searchCriteria1: "vrn", VRNMappingMasterId: selectedVehicle })
        this.HSSEScore_bar();
        this.HSSEIncident_bar();
    }

    async groupChange2(selectedGroup) {

        await this.setState({ searchCriteria1: "vrngroup", VRNGroupMasterId: selectedGroup })
        this.HSSEScore_bar();
        this.HSSEIncident_bar();
    }


    async HSSEScore_Pie() {

        let DateRange = this.state.TimeFrameId2;
        this.setState({ showReport: false })
        let UserBranchID = localStorage.getItem('selectedBranch')
        let reportName = "PieChart_HSSEScore";
        let URL_PARAMETERS = 'reportName=' + reportName + '&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.searchCriteria1 == "vrngroup") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectedCriteria=' + this.state.searchCriteria1 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }
        let reportViewType = this.state.reportViewType
        let ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        await this.setState({ srcURL_HSSEScore_Pie: ReportFullURL, showReport: true })
    }

    async HSSEIncident_Pie() {

        let DateRange = this.state.TimeFrameId1;
        this.setState({ showReport: false })
        let UserBranchID = localStorage.getItem('selectedBranch')
        let reportName = "PieChart_HSSEViolations";
        let URL_PARAMETERS = 'reportName=' + reportName + '&SelectedCriteria=' + this.state.searchCriteria1 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.searchCriteria1 == "vrngroup") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectedCriteria=' + this.state.searchCriteria1 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }

        let reportViewType = this.state.reportViewType
        let ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        await this.setState({ srcURL_HSSEIncidents_Pie: ReportFullURL, showReport: true })
    }

    async HSSEScore_bar() {

        let DateRange = this.state.TimeFrameId2;
        this.setState({ showReport: false })
        let UserBranchID = localStorage.getItem('selectedBranch')
        let reportName = "BarChart_HSSEScore";
        let URL_PARAMETERS = 'reportName=' + reportName + '&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')

        URL_PARAMETERS = 'reportName=' + reportName + '&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.searchCriteria1 == "vrngroup" && this.state.VRNGroupMasterId != "") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }
        else if (this.state.searchCriteria1 == "vrn" && this.state.VRNMappingMasterId != "") {
            URL_PARAMETERS = 'reportName=' + reportName + '&MappingMasterID=' + this.state.VRNMappingMasterId + '&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }

        let reportViewType = this.state.reportViewType
        let ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        await this.setState({ srcURL_HSSEScore_bar: ReportFullURL, showReport: true })
    }
    async HSSEIncident_bar() {

        let DateRange = this.state.TimeFrameId2;
        this.setState({ showReport: false })
        let UserBranchID = localStorage.getItem('selectedBranch')
        let reportName = "BarChart_HSSEViolations";
        let URL_PARAMETERS = 'reportName=' + reportName + '&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.searchCriteria1 == "vrngroup" && this.state.VRNGroupMasterId != "") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }
        else if (this.state.searchCriteria1 == "vrn" && this.state.VRNMappingMasterId != "") {
            URL_PARAMETERS = 'reportName=' + reportName + '&MappingMasterID=' + this.state.VRNMappingMasterId + '&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }

        let reportViewType = this.state.reportViewType
        let ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        await this.setState({ srcURL_HSSEIncident_bar: ReportFullURL, showReport: true })
    }

    /*End:For Bar Chart*/


    async changeOptionTime(selectedOption) {
        await this.setState({ TimeFrameId: selectedOption.value })
    }

    async optionChange(selectedOption) {
        // if (this.state.Option != selectedOption && selectedOption == 1) {
        if (selectedOption == 1) {

            await this.setState({ Option: selectedOption, Group: 0, Vehicle: 0 })

            this.getHighestHSSEEventTable1Data();

        }
        else
            await this.setState({ Option: selectedOption, Group: 0, Vehicle: 0 })
    }

    async vehicleChange(selectedVehicle) {


        await this.setState({ Vehicle: selectedVehicle, Group: 0 })
        this.getHighestHSSEEventTable1Data()
    }

    async groupChange(selectedGroup) {

        await this.setState({ Group: selectedGroup, Vehicle: 0 })
        this.getHighestHSSEEventTable1Data()
    }
        /* Start of Tabular Data */

    async BulletInOptionChange(selectedOption) {
            console.log("selected option is now ", selectedOption)
            if (selectedOption == 1) {
                await this.setState({ BulletInsearchCriteria: "vrn" })
                this.getTabularData();
            }
            else
                await this.setState({ BulletInOption: selectedOption, BulletInGroup: 0 })
    }
    
    async BulletInVehicleChange(selectedVehicle) {
    
    
            // await this.setState({ Vehicle: selectedVehicle, Group: 0 })
    
    }
    
    async BulletInGroupChange(selectedGroup) {
            //console.log("Select Groups are :", selectedGroup)
    
            await this.setState({ BulletInsearchCriteria: "vrngroup", BulletInVRNGroupMultiID: selectedGroup })
             this.getTabularData();
    
    }
    
        /* End of Tabular Data */

    async getTabularData() {
            let DateRange = this.state.BulletTimeFrame;
            let UserBranchID = localStorage.getItem('selectedBranch')
            let reportName = "SafetyMinAvgMaxTrend";
            let URL_PARAMETERS = 'reportName=' + reportName + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
            if (this.state.BulletInsearchCriteria == "vrngroup") {
                URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.BulletInVRNGroupMultiID + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
            }
    
            let reportViewType = this.state.reportViewType
            let ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
            console.log('URL Generated: ', ReportFullURL)
            await this.setState({ srcURL_HSSEBulletin: ReportFullURL})
    }



    render() {

        return (

            <div>

                <Container>
                    <Row>
                        <Card style={{ width: '100%', height: '50px' }}>
                            <Card.Body>
                                <a href="./MyReports" style={{ color: 'blue' }}>
                                    <p>For more details on your fleet’s performance, click here to visit My Reports</p>
                                </a>
                            </Card.Body>
                        </Card>

                    </Row>

                    {/* <Row>
                        <Col xs={2} >
                            <div style={{ height: "180px" }} >
                                <Card className="text-center bg-shell h-100" style={{ boxShadow: '0px 0px 10px 2px rgba(64, 64, 64, 0.6)' }}>
                                    <div className="card-content mt-6" style={{ margin: 'auto' }}>
                                        <Card.Header className="text-center">
                                        </Card.Header>

                                        <Card.Body>
                                            <div className="avatar avatar_shell bg-rgba-shell p-50 m-0 mb-1">
                                                <i className="fa fa-exclamation-triangle font-medium-5" />
                                            </div>
                                            <h2 className="text-bold-700" style={{ color: '#595959', margin: 'auto', fontSize: '18px' }}>Safety</h2>
                                        </Card.Body>
                                    </div>
                                </Card>
                            </div>
                        </Col>
                        <Col>
                            <CardDeck>
                                <HomeMini quantityPrice={this.state.HSSE_SCORE.currentMonthReading} Icon="fa fa-truck text-warning font-medium-5" percentage="-1" description="HSSE Score" cssName="avatar bg-rgba-warning p-50 m-0 mb-1" />
                                <HomeMini quantityPrice={this.state.HARSH_BRAKING.currentMonthReading} Icon="fa fa-empire text-success font-medium-5" percentage="-1" description="Incidents of Harsh Braking" cssName="avatar bg-rgba-success p-50 m-0 mb-1" />
                                <HomeMini quantityPrice={this.state.HARSH_ACCELERATION.currentMonthReading} Icon="fa fa-road text-primary font-medium-5" percentage="-1" description="Incidents of Harsh Acceleration" cssName="avatar bg-rgba-primary p-50 m-0 mb-1" />
                                <HomeMini quantityPrice={this.state.HARSH_TURN.currentMonthReading} Icon="fa fa-eercast text-info font-medium-5" percentage="-1" description="Incidents of Harsh Turn" cssName="avatar bg-rgba-info p-50 m-0 mb-1" />
                                <HomeMini quantityPrice={this.state.OVER_SPEEDING.currentMonthReading} Icon="fa fa-car text-danger font-medium-5" percentage="-1" description="Incidents of Overspeeding" cssName="avatar bg-rgba-danger p-50 m-0 mb-1" />
                            </CardDeck>

                        </Col>
                    </Row> */}

                    <Row>

                        <Col className="col-md-12">

                        <Card>
                            <Card.Title>
                                <h3 class="text-left p-4">HSSE Bulletin</h3>
                            </Card.Title>


                            <Card.Body>
                                <div className="form-group">
                                    <Row>

                                        <div className="form-group col-lg-4 col-md-12">
                                            <h5>Choose Time Frame</h5>
                                        </div>
                                        <div className="form-group col-lg-3 col-md-12">
                                            <Select
                                                options={this.state.timeFrameDropDownOptions}
                                                styles={customStyles}
                                                onChange={this.changeOptionTime}
                                                defaultValue={{ label: "Last 3 months", value: 1 }}
                                                isDisabled={true}
                                            >
                                            </Select>
                                        </div>
                                    </Row>

                                    <Row>

                                        <div className="col-md-4">
                                            <h5>Choose Base</h5>
                                        </div>
                                        <div className="col-md-3">

                                            <GroupVRNSelect
                                                isMultiInGroup='true'
                                                onOptionChange={this.BulletInOptionChange}
                                                onGroupChange={this.BulletInGroupChange}
                                                onVehicleChange={this.BulletInVehicleChange}
                                            />


                                        </div>
                                    </Row>

                                </div>

                                <Row>
                                    <div className="col-xl-12 col-lg-12 col-md-12 p-0 pr-2">
                                        <Card>
                                            <Card.Body className="p-0">
                                            <Iframe src={this.state.srcURL_HSSEBulletin} height="430" width="1250" />
                                                
                                            </Card.Body>
                                        </Card>
                                    </div>
                                </Row>

                            </Card.Body>
                        </Card>

                    </Col>


                    </Row>


                    <Row>
                        <Col className="col-md-12">

                            <Card>
                                <Card.Title>
                                    <h3 class="text-left p-4">Safety Analysis</h3>
                                </Card.Title>


                                <Card.Body>
                                    <div className="form-group">
                                        <Row>

                                            <div className="form-group col-lg-4 col-md-12">
                                                <h5>Choose Time Frame</h5>
                                            </div>
                                            <div className="form-group col-lg-3 col-md-12">
                                                <Select
                                                    options={this.state.timeFrameDropDownOptionsNew}
                                                    styles={customStyles}
                                                    onChange={this.changeOptionTime2}
                                                    defaultValue={{ label: "Last 3 months", value: "three_month" }}
                                                    isDisabled={true}
                                                >
                                                </Select>
                                            </div>
                                        </Row>

                                        <Row>

                                            <div className="col-md-4">
                                                <h5>Choose Base</h5>
                                            </div>
                                            <div className="col-md-3">
                                                <GroupVRNSelect
                                                    isMultiInGroup='true'
                                                    isMultiInVehicle='true'
                                                    showVehiclesInDropDown='yes'
                                                    onOptionChange={this.optionChange2}
                                                    onGroupChange={this.groupChange2}
                                                    onVehicleChange={this.vehicleChange2}
                                                />
                                            </div>
                                        </Row>

                                    </div>

                                    <Row>
                                        <div className="col-md-12 p-0 pr-2">
                                            <Card>
                                                <Card.Body className="p-0">
                                                    <div className="tab-pane active" id="pieTab" role="tabpanel" aria-labelledby="home-tab-justified">
                                                        <Row>
                                                            <div className="col-md-6 col-12">
                                                                <Card style={{ border: '1px solid #ccc' }}>
                                                                    <Card.Body className="p-0">
                                                                        <Iframe src={this.state.srcURL_HSSEScore_bar} height="430" width="100%" />
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>

                                                            <div className="col-md-6 col-12">
                                                                <Card style={{ border: '1px solid #ccc' }}>
                                                                    <Card.Body className="p-0">
                                                                        <Iframe src={this.state.srcURL_HSSEIncident_bar} height="430" width="100%" />
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>

                                                        </Row>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </div>

                                    </Row>

                                </Card.Body>
                            </Card>



                        </Col>
                    </Row>


                </Container>
            </div>
        );
    }
}

export default HSSEAnalysis;
